import React from "react";
import { useSelector } from "react-redux";
import { getFirstChar, renderMonth } from "../../../../helpers/common";

export const getStartData = (additionalFields) => {
  if (!additionalFields) return "";

  // Support both camelCase (startMonth) and snake_case (start_month)
  const monthRaw = additionalFields?.startMonth ?? additionalFields?.start_month;
  const year = additionalFields?.startYear ?? additionalFields?.start_year;

  const month = typeof renderMonth === "function" ? renderMonth(monthRaw) : monthRaw;

  // Combine month and year, filtering out empty/undefined values
  const dateStr = [month, year].filter(Boolean).join(" ").trim();

  return dateStr || "";
};

export const getEndData = (additionalFields) => {
  if (!additionalFields) return "";

  // Check for currently working status (handles "Yes", true, "1", 1)
  const isCurrent =
    additionalFields?.is_currently_working === "Yes" ||
    additionalFields?.is_currently_working === true ||
    additionalFields?.currently_working === "Yes" ||
    additionalFields?.currently_working === true ||
    additionalFields?.is_current === true ||
    additionalFields?.is_current === "1";

  if (isCurrent) {
    return "Present";
  }

  // Support both camelCase (endMonth) and snake_case (end_month)
  const monthRaw = additionalFields?.endMonth ?? additionalFields?.end_month;
  const year = additionalFields?.endYear ?? additionalFields?.end_year;

  const month = typeof renderMonth === "function" ? renderMonth(monthRaw) : monthRaw;

  // Combine month and year, filtering out empty/undefined values
  const dateStr = [month, year].filter(Boolean).join(" ").trim();

  return dateStr || "";
};

const ExperienceJourney = ({
  handleOpenExperienceModal,
  componentType = "overview",
}) => {
  const { experiences } = useSelector((state) => state.customer);

  // Helper function to safely parse additionalFields in case it is a stringified JSON
  const getParsedFields = (fieldData) => {
    if (!fieldData) return {};
    if (typeof fieldData === "object") return fieldData;
    try {
      return JSON.parse(fieldData);
    } catch (e) {
      return {};
    }
  };

  // 🟢 FIXED: Safe start date formatter mapping both new flat fields and legacy keys
  const getStartData = (item, af) => {
    const month = item?.startMonth || af?.start_month || "";
    const year = item?.startYear || af?.start_year || "";
    return month && year ? `${month} ${year}` : year || month || "";
  };

  // 🟢 FIXED: Safe end date formatter mapping both new flat fields and legacy keys
  const getEndData = (item, af) => {
    const isWorking = item?.isCurrentlyWorking !== undefined
      ? item.isCurrentlyWorking
      : (af?.is_currently_working === "Yes" || af?.is_currently_working === true);

    if (isWorking) {
      return "Present";
    }

    const month = item?.endMonth || af?.end_month || "";
    const year = item?.endYear || af?.end_year || "";
    return month && year ? `${month} ${year}` : year || month || "";
  };

  // 🟢 FIXED: Unified helper to format the company details and active dates
  const getCompanyAndYear = (item, af) => {
    let companyAndYear = "";
    
    // Check flat API parameter "company" first, fallback to additional_fields properties
    const company = item?.company || af?.company_name || af?.university_college || ""; 
    const sYear = item?.startYear || af?.start_year || "";

    if (company) {
      companyAndYear += `${company} `;
    }

    if (sYear) {
      companyAndYear += `(${getStartData(item, af)} - ${getEndData(item, af)})`;
    }

    return companyAndYear;
  };

  return (
    <>
      {experiences && experiences.length > 0 ? (
        experiences.map((item) => {
          // Parse additionalFields safely for legacy compatibility support
          const af = getParsedFields(item?.additionalFields || item?.additional_fields);

          // 🟢 FIXED: Read flat API 'position' first, fallback to name or legacy additionalFields keys
          const position = item?.position || item?.name || af?.position || af?.title || "Work Experience";
          const details = item?.details || af?.details || "";

          return (
            <div key={item?.id} className="candidate-education-content mt-4 d-flex">
              <div className="circle flex-shrink-0 bg-soft-primary">
                {getFirstChar(position)}
              </div>
              <div className="ms-4">
                <div className="d-flex">
                  <h6 className="fs-16 mb-1 me-3 text-capitalize">
                    {position}
                  </h6>

                  {componentType === "update" && (
                    <div
                      className="cursor-pointer"
                      onClick={() => handleOpenExperienceModal("update", item)}
                    >
                      <i className="uil uil-edit"></i>
                    </div>
                  )}
                </div>

                <p className="mb-2 text-muted text-capitalize">
                  {getCompanyAndYear(item, af)}
                </p>
                {details && <p className="text-muted">{details}</p>}
              </div>
            </div>
          );
        })
      ) : (
        <p className="mt-4 mb-5">No work experiences have been added.</p>
      )}
    </>
  );
};

export default ExperienceJourney;
